import { __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const Comment = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M5.5,5 C5.224,5 5,5.225 5,5.5 L5,15.5 C5,15.775 5.224,16 5.5,16 L8.5,16 C8.776,16 9,16.224 9,16.5 L9,19.928 L13.163,16.131 C13.255,16.047 13.375,16 13.5,16 L18.5,16 C18.776,16 19,15.775 19,15.5 L19,5.5 C19,5.225 18.776,5 18.5,5 L5.5,5 Z M8.947,21.002 C8.818,21.002 8.687,20.975 8.562,20.92 C8.215,20.767 8,20.436 8,20.057 L8,17 L5.5,17 C4.673,17 4,16.327 4,15.5 L4,5.5 C4,4.673 4.673,4 5.5,4 L18.5,4 C19.327,4 20,4.673 20,5.5 L20,15.5 C20,16.327 19.327,17 18.5,17 L13.694,17 L9.578,20.754 L9.578,20.755 C9.399,20.917 9.175,21.002 8.947,21.002 L8.947,21.002 Z", fillRule: "evenodd" })));
};
Comment.displayName = 'Comment';
export default Comment;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Comment.js.map